
import {CommonCitationsType} from '@/store/content-optimizer/CurrentPageModel';
import {Tooltip} from 'antd';
import {observer} from 'mobx-react';
import styles from '../style.module.scss';
import {NextImg} from '@/utils/nextImg';

interface Props {
  citation: CommonCitationsType;
}

export const SingleCitation = observer(({citation}: Props) => {
  const addDefaultSrc = e => {
    e.target.src = '/img/world-wide-web.svg';
  };

  return (citation?.url && !citation?.url.startsWith('javascript:')) && <div className={styles.singleCitation}>
    <div className={styles.citationIcon}>{citation.url && <NextImg onError={e => addDefaultSrc(e)} src={`https://www.google.com/s2/favicons?sz=16&domain_url=${citation.url}`} />}</div>
    <div className={styles.citationInfo}>
      <div className={styles.citationName}>{citation?.title}</div>

      {citation?.url ?
        <a target='_blank' rel='noreferrer' href={citation?.url} className={styles.citationUrl}>{citation?.url}</a> : null}
      {citation?.metaDesc && citation?.metaDesc.length > 90 ?
        <Tooltip
          placement='left'
          title={citation?.metaDesc}
          overlayClassName={styles.metaDescTooltip}>
          <div className={styles.citationText}>{citation?.metaDesc.substring(0, 90) + '...'}</div>
        </Tooltip> : <div className={styles.citationText}>{citation?.metaDesc}</div>}
      {citation?.serps ? <div className={styles.serpUsedByContainer}>
        <span style={{fontSize: '10px', marginTop: '5px', marginBottom: 'auto', marginRight: '6px'}}>Used by:</span> <div className={styles.citationSerpsContainer}>
          {citation?.serps?.map((serp, idx) => idx < 5 && (
            <Tooltip
              key={idx}
              title={<>
                <div className={styles.serpTitle}>{serp.title}</div>
                {serp?.url ? <a target='_blank' rel='noreferrer' href={serp.url} className={styles.serpUrl}>{serp.url}</a> : null}
                <div className={styles.citationSerpMetaDesc}>{serp.metaDesc && serp.metaDesc.length > 70 ? serp.metaDesc.substring(0, 70) + '...' : serp.metaDesc}</div>
                <div className={styles.citationSerPosition}>{`Position: ${serp.position}`}</div>
              </>}
              overlayClassName={styles.serpTooltip}>
              <div className={styles.serpIcon}><NextImg
              // onError={e => addDefaultSrc(e)}
                src={`https://www.google.com/s2/favicons?sz=16&domain_url=${serp.url}`} /></div>
            </Tooltip>
          ))}
          {citation?.serps?.length > 7 && (
            <span>{`+${citation?.serps?.length - 7}`}</span>
          )}
        </div>
      </div> : null}

    </div>
  </div>;
});
